import { useQueryClient } from '@tanstack/react-query';
import { ErrorInfo } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ContentErrorFallback } from '../../components/ErrorFallback/ContentErrorFallback';
import { useLogger } from '../../context/useLogger';
import { logError } from '../../utils/logHelper';

// Niveau 2 : zone privée (navbar + footer) — invalide les queries utilisateur
export function PrivateMainErrorBoundary({
  children,
  errorLayout,
}: Readonly<{ children: React.ReactNode; errorLayout: string }>) {
  const logger = useLogger();
  const queryClient = useQueryClient();

  return (
    <ErrorBoundary
      FallbackComponent={ContentErrorFallback}
      onError={(error: unknown, info: ErrorInfo) => {
        const fallBackError =
          error instanceof Error ? error : new Error(`Unknown error on ${errorLayout}`);
        logError(logger, fallBackError, info);
      }}
      onReset={() => {
        void queryClient.invalidateQueries({ queryKey: ['userInfo'] });
        logger.info(`ErrorBoundary reset - ${errorLayout}`);
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
